import React from "react";
import Configurer from "../../components/Configurer";
import TLink from "../../components/TLink";
import { checkTranslation, imageAddress, priceStandardView, translate } from "../../utils/useful";
import moment from "jalali-moment";
import HttpServices from "../../utils/Http.services";
class CommissionsApplet extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

            info: [
                { title: 'connection', value: "group Name" },
                { title: 'Applets', value: "4 Active" },
                { title: 'Public Posts', value: "12 Posts" },
                { title: 'Expertise', value: "View Info" }

            ],
            hasMoreUpdates: true
        }
    }

    componentDidMount() {
        this.fetch()
    }


    fetch = (id) => {

        this.setState({ isLoading: true, errors: {} })

        if (this.state.payment?._id) {
            id = this.state.payment?._id
        }

        HttpServices.request("getCommissions", { id }, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })
            console.log(fetchResult)

            if (fetchError) {

                this.setState({ pageStatus: 404 })
                return
            }

            if (fetchResult.info) {

                this.setState({ data: fetchResult.info })

            }

        })

    }

    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: false, showTabBar: true, showHeader: false, headerTitle: checkTranslation(this.state.pageTitle), button: {} }}
                title={checkTranslation(this.state.pageTitle)}
                description={translate("Home Description")}
                className=""
            >
                <div className=" w-100 d-flex flex-column" style={{ position: 'relative', backgroundColor: '#fff', minHeight: 'calc(100vh-45px)' }}>

                    {/* <div className="w-100 pb-4 pt-5 px-5 " style={{ backgroundImage: 'linear-gradient(to bottom, #18a2a5,#8cd9c0)', borderRadius: '0px 0px 30px 30px' }}> */}
                    {/* <div className="w-100 pb-4 pt-5 px-5 " style={{ backgroundImage: 'linear-gradient(to left bottom, rgba(100,100,250),rgba(174,67,180))', borderRadius: '0px 0px 30px 30px' }}> */}
                    <div className="w-100 pb-4 pt-5 px-5 " style={{ backgroundImage: 'linear-gradient(to left bottom, rgba(00,00,18),rgba(6,12,38))', borderRadius: '0px 0px 30px 30px' }}>
                        {/* <div className="w-100 pb-4 pt-5 px-5 " style={{ backgroundImage: 'linear-gradient(to left bottom, rgb(255, 197, 0),rgb(220, 150, 40))', borderRadius: '0px 0px 30px 30px' }}> */}

                        <div className="row">
                            <div className="flexc col-12 col-md-6">
                                <div className="mrd-4 flexcc">
                                    <img src={'/images/icons/' + this.props.applet?.type + ".svg"} style={{ border: '3px solid #ffffff50', height: 100, width: 100, objectFit: 'cover', borderRadius: '50%', border: '1px solid #eeeeee10', boxShadow: '0px 0px 15px #00000020' }} />
                                </div>
                                <div>
                                    {/* <p className="text-small" style={{ color: '#ffffffff' }}>Yonnect User</p> */}
                                    <TLink to={'/' + (this.props.applet?.user?.username ?? ('p/' + this.props.applet?.user?._id))} >
                                        <p className="text-normal mt-1" style={{ color: '#ffffffdd' }}>{this.props.applet?.user?.fullname}</p>
                                    </TLink>

                                    <h1 className="text-ultra-big text-bold" style={{ color: '#fff' }}>{this.props.applet?.name}</h1>
                                    {/* {this.props.user?.username && (<p className="text-small mt-1" style={{ fontWeight: 'normal', backgroundColor: '#fff', padding: '4px 10px', borderRadius: 20, color: '#789' }}>@{this.props.user?.username}</p>)} */}

                                    {this.props.applet && this.props.applet?.description != '' && (<p className="mt-1 text-smaller" style={{ color: '#ffffffdd' }}>{this.props.applet?.description}</p>)}
                                </div>
                            </div>

                            <div className="flexc col-12 col-md-6 d-flex justify-content-md-end mt-4 mt-md-0">
                                <div className=" d-flex " style={{ boxShadow: '0px 0px 30px #00000020', backgroundColor: '#ffffffee', borderRadius: 15, padding: '16px 26px' }}>
                                    {/* <div>
                                        <img className="mrd-4" src={'/images/chat.svg'} style={{ filter: 'saturate(20%)' }} width="30px" />
                                    </div> */}
                                    <div>

                                        <div className="  w-100 flexcc flex-column">
                                            <span className="text-bold  text-big">$400</span>
                                            <p className="text-small ">Total Balance</p>
                                            <p className="text-smaller opacity-5 ">Your current total balance</p>

                                        </div>
                                    </div>
                                </div>
                            </div>





                            <div className="col-12" style={{ height: 120 }}>

                            </div>
                        </div>
                    </div>


                    <div className="" style={{ minHeight: 'calc(100vh - 100px)', margin: '0px 0px', marginTop: -100, backgroundColor: '#ffffffff', position: 'relative', borderRadius: '30px 30px 0px 0px', boxShadow: '0px 0px 30px #00203020' }}>
                        <div className="pt-4 px-4 pb-4" style={{ backgroundColor: '#f2f6f8', borderRadius: '30px 30px 0px 0px' }}>
                            {/* <h2 className="mt-0 mx-3 mb-1">Applets</h2>
                            <div className="flexc">
                                {Array.isArray(this.props.applets) && this.props.applets.map((prop, index) => {

                                    return (
                                        <div className=" mb-1 p-1 ">
                                            <div className="w-100">
                                                <TLink to={(this.props.user?.username ?? 'a') + "/" + prop.appletId?.urlcode} className="w-100">
                                                    <div className="flexc text-center flex-column" style={{ padding: '8px 10px' }} key={prop.appletId._id}>
                                                        <img className="mt-1" src={'/images/icons/' + prop.appletId.type + ".svg"} style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: '50%', border: '2px solid #eee' }} />
                                                        <div className="">
                                                            <p className="mb-0 text-normal mt-1" style={{ color: '#456' }}>{checkTranslation(prop.appletId.name)}</p>

                                                            <p className="m-0" style={{ fontSize: 12, color: '#758595' }}>{prop.appletId.type}</p>

                                                        </div>
                                                    </div>
                                                </TLink>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div> */}

                            <div className="pt-0 mt-0 flexc" style={{ borderTop: '0px solid #e0e4e8' }}>
                                <p className="mt-0 mx-1  mb-1 text-normal text-bold" style={{ backgroundColor: '#000', color: '#fff', borderRadius: 30, padding: '6px 10px' }}>Invoices</p>

                                <p className="mt-0 mx-1 mb-1 text-normal " style={{ color: '#000', borderRadius: 8, padding: '6px 10px' }}>Payments</p>

                            </div>

                        </div>



                        {/* <img src={'https://cdn.dribbble.com/users/60166/screenshots/9184781/media/4e889d372ebab499345347ad5e254962.jpeg'} width='100%' style={{ height: '600px', objectFit: 'cover' }} /> */}
                        <div className="container pt-4">
                            {(this.state.data == null || this.state.data.length == 0) ? (
                                <div className="text-center flexcc flex-column pt-5 w-100 mb-5">
                                    <p className="text-ultra-big text-bold " style={{ color: '#345' }} >No Data</p>
                                    <p className="text-small mt-2" style={{ color: '#345', maxWidth: '500px' }} >{translate('temp.lorem')}</p>
                                </div>
                            ) : (
                                <div className="row">
                                    {this.state.data.map((prop, index) => {
                                        return (
                                            <div className="col-12 col-md-6 col-lg-4 mb-3">
                                                <div className="p-3 px-4" style={{ backgroundColor: '#f2f6f8', borderRadius: 15 }}>
                                                    <p className="text-small" style={{ color: '#456' }}>{moment(prop.date).local('fa').format("jYYYY/jMM/jDD")}</p>
                                                    <p className='mt-1'>Total price: {priceStandardView(prop.amount ?? prop.list.total)}</p>
                                                    <p className='mt-1'>Commission: {priceStandardView(prop.amount * Number(prop.commission) / 100)}</p>
                                                    <p className='mt-1'>Customer: {prop.customer?.fullname}</p>

                                                    <div className="pt-1 mt-2" style={{ borderTop: '1px solid #eee' }}>
                                                        {/* <p className="text-small mt-1 " style={{ color: '#456' }}>Services</p> */}

                                                        {prop.list.items?.map((element, index) => {
                                                            return (
                                                                <div className="flexcb">
                                                                    <p className='mt-1 text-small'>{element?.item?.name}</p>
                                                                    <p className='mt-1 text-small'>{element?.quantity}</p>
                                                                </div>
                                                            )
                                                        })}

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}

                        </div>
                        {/* <div className="flexc">
                                    <div style={{ cursor: 'pointer', background: 'linear-gradient(to right bottom, #000, #111)', padding: '0px 2px 0px 12px', borderRadius: 20, color: '#fff', border: '1px solid #ffffff20', fontSize: 16, marginTop: 5, display: 'flex', alignItems: 'center' }}>
                                                <p className={"text-small"} style={{ fontWeight: 'bold' }}>Applets</p>
                                                <div className="d-flex justify-content-center align-items-center m-1" style={{ backgroundColor: '#ffffff', color: '#000', border: '1px solid #20202010', padding: 5, borderRadius: 30, height: 24, minWidth: 24 }}>
                                                    <p style={{ fontWeight: 'bold' }}>{this.props.applets?.length}</p>
                                                </div>
                                            </div>


                                    <button style={{ opacity: 0.7, cursor: 'pointer', padding: '0px 2px 0px 2px', borderRadius: 40, color: '#fff', fontSize: 16, marginTop: 5, fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                                        <img src="/images/more.svg" width="24px" />
                                    </button>
                                </div> */}


                    </div>



                    {/* <div className="W-100 flexcc" >
                    <img className="w-100" src="https://images.unsplash.com/photo-1619417818864-3b119a495f70?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1789&q=80" />
                </div>

                <div className="w-100" style={{ position: 'relative' }}>
                    <div className="m-0" style={{ backgroundColor: '#fff', width: '100%', padding: 0 }}>
                        <div className="text-center p-5">
                            <span className="m-0" style={{ fontSize: 25 }}>Page Builder info</span>
                        </div>
                    </div>

                </div> */}
                </div>
            </Configurer>
        )
    }
}

export default CommissionsApplet;

